<template>
	<Chart v-if="chartData" type="radar" :data="chartData" :options="chartOptions" class="w-full h-full" />
</template>

<script setup lang="ts">
import { computed } from "vue"
import Chart from "primevue/chart"

interface DatasetInput {
	label: string
	values: number[]
	color: string
}

const props = defineProps<{
	labels: string[]
	datasets: DatasetInput[]
}>()

const COLORS = ["#4472C4", "#ED7D31", "#A5A5A5", "#FFC000", "#5B9BD5", "#70AD47", "#264478", "#9B57A0"]

const chartData = computed(() => {
	if (!props.labels?.length || !props.datasets?.length) return null

	return {
		labels: props.labels,
		datasets: props.datasets.map((ds, idx) => ({
			label: ds.label,
			data: ds.values,
			borderColor: ds.color || COLORS[idx % COLORS.length],
			backgroundColor: `${ds.color || COLORS[idx % COLORS.length]}33`,
			pointBackgroundColor: ds.color || COLORS[idx % COLORS.length],
			pointBorderColor: "#fff",
			pointHoverBackgroundColor: "#fff",
			pointHoverBorderColor: ds.color || COLORS[idx % COLORS.length],
			fill: true,
		})),
	}
})

const chartOptions = computed(() => ({
	responsive: true,
	maintainAspectRatio: false,
	plugins: {
		legend: {
			position: "bottom" as const,
			labels: { usePointStyle: true, padding: 12 },
		},
	},
	scales: {
		r: {
			beginAtZero: true,
			ticks: { display: true, stepSize: 0.25 },
			pointLabels: { font: { size: 11 } },
		},
	},
}))
</script>
